import styled from 'styled-components'
import { BgGetStartedHeader } from 'assets/images'
import { breakpoints, colors } from 'style'

export const GetStartedHeroContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vw / 2.5);
  min-height: 300px;
  display: flex;
  flex-direction: column;
  background-image: url(${BgGetStartedHeader});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  .container {
    .get-header-content {
      padding-top: 50px;
      h1 {
        color: ${colors.dark8};
      }
    }
  }
  @media (max-width: ${breakpoints.xl}px) {
    /* height: 600px; */
  }
  @media (max-width: ${breakpoints.md}px) {
    /* height: 500px; */
  }
  @media (max-width: ${breakpoints.sm}px) {
    /* height: 297px; */
    justify-content: flex-end;
    .container {
      .get-header-content {
        height: 100%;
        display: flex;
        align-items: flex-end;
        padding-bottom: 50px;
        h1 {
          color: ${colors.white};
        }
      }
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
